import { Song, TrackingStatusEnum } from 'src/features/Dashboard';
import { AddTrackObj } from 'src/features/Purchase/MultiAsset';

export const isCasterReleaseSong = (track: AddTrackObj): boolean => {
  if (track) {
    return track?.file === undefined;
  }

  return false;
};

/* Scenario 0 - first purchase or subsequent ones */
export const isFirstPurchase = (tracks: AddTrackObj[]): boolean => {
  return tracks.length > 0;
};

/* Scenario 1 (extend) - active, warning and day 1 of expiration */
export const isExtendDayOne = (song?: Song): boolean => {
  return !!song && song?.selected_tracking_period?.remainingDays >= 0;
};

/* Scenario 2 (extend) -  expired within 90 day period - starting day 2 of expiration until day 90  */
export const isExtendWithinNinetyDays = (song?: Song): boolean => {
  return (
    !!song &&
    song?.selected_tracking_period?.status === TrackingStatusEnum.EXPIRED
  );
};

/* Scenario 3 (renew) -  expired past 90 day period - starting day 91  */
export const isRenewPastNinetyDays = (song?: Song): boolean => {
  return (
    !!song &&
    song.selected_tracking_period.status === TrackingStatusEnum.PAST_EXPIRED
  );
};

// Getting tracking status
export const trackingStatus = (days: number) => {
  if (days < 1 && days >= -90) {
    return TrackingStatusEnum.EXPIRED;
  }
  if (days < -90) {
    return TrackingStatusEnum.PAST_EXPIRED;
  }
  if (days <= 5) {
    return TrackingStatusEnum.EXPIRING;
  }

  return TrackingStatusEnum.ACTIVE;
};

// Getting days left
export const daysLeft = (endTrackingOn: Date) => {
  return Math.round(
    (endTrackingOn.valueOf() - new Date().valueOf()) / (1000 * 60 * 60 * 24) + 1 // adding plus one to considere last day as well
  );
};

// Getting days to start
export const getDaysToStart = (startTrackingOn: string) => {
  const pastDate = new Date(startTrackingOn);
  const currentDate = new Date();

  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const diffInMilliseconds = pastDate.getTime() - currentDate.getTime();
  const diffInDays = Math.ceil(diffInMilliseconds / millisecondsPerDay);
  return diffInDays;
};

// Validate all count spins detection
export const validateSpinsDetection = (spinsAllCount: number) => {
  return spinsAllCount !== 0;
};
